import {
	ADMINGETCURRENCYMAPPING_SUCCESS,
	ADMINGETCURRENCYMAPPING_FAILED,
	RESET_ADMINGETCURRENCYMAPPING,
	LOADING_ADMINGETCURRENCYMAPPING,
	NETWORK_ERROR_ADMINGETCURRENCYMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETCURRENCYMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINGETCURRENCYMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINGETCURRENCYMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINGETCURRENCYMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINGETCURRENCYMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
